import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { InclusionsAndExclusionsComponent } from '../../inventory-itinerary/add/inclusions-and-exclusions/inclusions-and-exclusions.component';
import { TermsAndConditionsComponent } from '../../inventory-itinerary/add/terms-and-conditions/terms-and-conditions.component';
import { CancellationPolicyComponent } from '../../inventory-itinerary/add/cancellation-policy/cancellation-policy.component';
import { ImportantInformationComponent } from '../../inventory-itinerary/add/important-information/important-information.component';
import { VoucherService } from 'src/app/business-service/voucher/voucher.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { ENTITY_NAMES, MEAL_PLANS, RECORD_STATUS_VALUES, TRANSPORTATION_TYPES } from '../../shared/constants/api-constants';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router } from '@angular/router';
import { StatusUpdateService } from 'src/app/business-service/status-update/status-update.service';


@Component({
  selector: 'app-voucher-form',
  templateUrl: './voucher-form.component.html',
  styleUrls: ['./voucher-form.component.scss'],
})
export class VoucherFormComponent implements OnInit {

  @Input() clientId: any;
  @Input() leadId: any;
  leadDetails: any;
  @Input() quoteId: any;
  @Input() editVoucherId: any;

  @Output() voucherFormSubmitted: EventEmitter<any> = new EventEmitter<any>;

  @ViewChild(InclusionsAndExclusionsComponent) inclusionsAndExclusionsComponent!: InclusionsAndExclusionsComponent;
  @ViewChild(TermsAndConditionsComponent) termsAndConditionsComponent!: TermsAndConditionsComponent;
  @ViewChild(CancellationPolicyComponent) cancellationPolicyComponent!: CancellationPolicyComponent;
  @ViewChild(ImportantInformationComponent) importantInformationComponent!: ImportantInformationComponent;

  quoteData: any;
  voucherData: any;

  serviceBasedSections: any;
  voucherTypeVisibility: any = {
    accommodationVoucher: true,
    transportationVoucher: true,
    transfersVoucher: true,
    sightSeeingVoucher: true
  };
  dmcPackageQuote: boolean = false;

  storedInclusionData: any;
  storedTerms: any;
  storedCancellation: any;
  storedInformation: any;

  voucherForm!: FormGroup;
  voucherFormIsDirty: boolean = false;
  confirmDismiss: boolean = false;
  dismissTimeout: any;

  //Prefernce Data
  noOfAdults: number = 0;
  noOfChildren: number = 0;
  noOfInfants: number = 0;
  totalNoOfDays: any = 0;


  // LOV data
  typesOfMeals: any = [];
  meals: any = [];
  accommodationType: any;
  roomType: any = [];
  roomCategory: any = [];
  MEAL_PLAN = MEAL_PLANS;

  hideInvoice: any;

  constructor(
    private _modalController: ModalController,
    private _fb: FormBuilder,
    private _responseNotificationService: ResponseNotificationService,
    private _globalService: GlobalService,
    private _lovDataService: LovDataService,
    private _itineraryService: ItineraryService,
    private _voucherService: VoucherService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _validationService: InputValidationsService,
    private _leadService: LeadsService,
    private _contactService: ContactsService,
    private _router: Router,
    private _statusUpdateService: StatusUpdateService
  ) { }


  async ngOnInit() {
    this._globalService.roles$.subscribe((roles) => {
      if (roles) {
        const invoiceModule = roles.modules.find((module: any) => module.name === "Invoice & Receipts");
        if (!invoiceModule || !invoiceModule.permissions) {
          this.hideInvoice = true;
        }
      }
    })

    this.voucherForm = this._fb.group({
      // hotels
      accommodationNotes: [''],
      accommodations: this._fb.array([]),
      accommodationsTermsAndConditions: [[]],
      hotelsAck: [false],
      showHotels: [true],
      guestDetailsMandatory: [true], 
      // Transportation
      transportationNotes: [''],
      transportations: this._fb.array([]),
      transfersAck: [false],
      showTransportation: [true],
      bookingDetailsMandatory: [true],  
      // transfers
      transfersNotes: [''],
      tranfersCars: this._fb.array([]),
      showTransfer: [true],
      // sightseeing
      sightSeeingNotes: [''],
      sightSeeingDays: this._fb.array([]),
      showSightSeeing: [true],
      showInclusions: [true],
      showTerms: [true],
      showCancellation: [true],
      showImportantInfo: [true],
      showNotes: [true],
      voucherNotes: ['']
    });

    // Subsribe to section visible changes using toggle
    this.voucherForm.get('showHotels')?.valueChanges.subscribe(() => {
      this.updateSectionValidations();
    })
    this.voucherForm.get('guestDetailsMandatory')?.valueChanges.subscribe((mandatory: boolean) => {
      this.updateGuestDetailsValidations();
      if (!mandatory) {
        this.clearAllGuestDetails();
      }
    })
    this.voucherForm.get('showTransportation')?.valueChanges.subscribe(() => {
      this.updateSectionValidations();
    })
    this.voucherForm.get('bookingDetailsMandatory')?.valueChanges.subscribe((mandatory: boolean) => {
      this.updateBookingDetailsValidations();
      if (!mandatory) {
        this.clearAllBookingDetails();
      }
    })


    this.voucherForm.get('showTransfer')?.valueChanges.subscribe(() => {
      this.updateSectionValidations();
    })
    this.voucherForm.get('showSightSeeing')?.valueChanges.subscribe(() => {
      this.updateSectionValidations();
    })

    // Getting LOV data from service

    this._lovDataService.getLovData("HotelType").subscribe((data) => {
      if (data) {
        this.accommodationType = data;
      }
    });
    this._lovDataService.getLovData("RoomCategory").subscribe((data) => {
      if (data) {
        this.roomCategory = data
      }
    });
    this._lovDataService.getLovData("RoomType").subscribe((data) => {
      if (data) {
        this.roomType = data;
      }
    });
    this._lovDataService.getLovData("Meals").subscribe((data) => {
      this.meals = data;
      this.typesOfMeals = data.map((item: { name: any }) => item.name);
    })

    // Getting lead service and quote details
    if (this.leadId) {
      this.serviceBasedSections = await this._globalService.getLeadsTravelServices(this.leadId)

      this.voucherTypeVisibility = {
        accommodationVoucher: this.serviceBasedSections.showHotels ? true : false,
        transportationVoucher: this.serviceBasedSections.showTransportation ? true : false,
        transfersVoucher: this.serviceBasedSections.showTransfers && !this.serviceBasedSections.showTransportation ? true : false,
        sightSeeingVoucher: this.serviceBasedSections.showRouteCraft ? true : false
      }

      // assign clientid from leadId
      this._leadService.getLead(this.leadId).subscribe((data) => {
        this.leadDetails = data;
        this.clientId = data.clientId;
      })
    }

    if (this.editVoucherId) {
      this._voucherService.getVoucher(this.editVoucherId).subscribe(async (data) => {
        this.voucherData = data;
        this.voucherTypeVisibility = {
          accommodationVoucher: this.voucherData.accommodations ? true : false,
          transportationVoucher: this.voucherData.transportations ? true : false,
          transfersVoucher: this.voucherData.transfers ? true : false,
          sightSeeingVoucher: this.voucherData.routeCraft ? true : false
        }

        this.patchVoucherData(this.voucherData);

        this.storedInclusionData = this.deserializeInclusionData(this.voucherData.inclusionAndExclusions[0]);
        this.storedTerms = this.deserializeTermsAndConditionsData(this.voucherData.termsAndConditions[0]);
        this.storedCancellation = this.deserializeCancellationPolicyData(this.voucherData.cancellationPolicies[0]);
        this.storedInformation = this.deserializeImportantInformationData(this.voucherData.importantInformations[0]);

      }, (error) => {
        this._responseNotificationService.showMessage("Something went wrong,  please try again", true);

      })
    } else {
      if (this.quoteId) {
        this._itineraryService.getQuoteData(this.quoteId).subscribe(async (data) => {
          this.quoteData = data;
          this.noOfAdults = this.quoteData.itineraryDetails.totalAdults;
          this.noOfChildren = this.quoteData.itineraryDetails.totalChildrens;
          this.noOfInfants = this.quoteData.itineraryDetails.totalInfants;
          this.totalNoOfDays = this.quoteData.itineraryDetails.totalDays;

          if (this.voucherTypeVisibility.transportationVoucher && ((this.quoteData.flights && this.quoteData.flights?.data?.length) ||
            (this.quoteData.trains && this.quoteData.trains?.data?.length) ||
            (this.quoteData.buses && this.quoteData.buses?.data?.length) ||
            (this.quoteData.cars && this.quoteData.cars?.data?.length) ||
            (this.quoteData.ferries && this.quoteData.ferries?.data?.length) ||
            (this.quoteData.cruises && this.quoteData.cruises?.data?.length))) {
            this.voucherTypeVisibility.transportationVoucher = true;
          } else {
            this.voucherTypeVisibility.transportationVoucher = false;
          }

          if (this.voucherTypeVisibility.transfersVoucher && (this.quoteData.cars && this.quoteData.cars?.data?.length)) {
            this.voucherTypeVisibility.transfersVoucher = true;
          } else {
            this.voucherTypeVisibility.transfersVoucher = false;
          }

          // If dmc package is selected
          if (this.quoteData.itineraryDetails.packageId && this.quoteData.hotelPricingCollection) {
            this.dmcPackageQuote = true;
            this.serviceBasedSections.showRouteCraft = false;
            this.voucherTypeVisibility.sightSeeingVoucher = false;
            this.quoteData.accommodations = this.serializeDmcHotelsToAccomodation(this.quoteData.hotelPricingCollection);

          }
          this.patchQuoteData(this.quoteData);
        })
      }
    }
  }

  serializeDmcHotelsToAccomodation(dmcPackages: any) {
    if (!dmcPackages || !Array.isArray(dmcPackages.packages)) {
      return { data: [] };
    }

    const data = dmcPackages.packages.flatMap((pkg: any) =>
      pkg.locations.map((loc: any) => ({
        destination: loc.locationName,
        locations: [
          {
            locationName: loc.locationName,
            hotels: [
              {
                index: 1, 
                preferredOption: true,
                location: loc.locationName,
                hotelName: loc.hotelName,
                TotalRooms: 0, 
                noOfNights: loc.nights || 0,
                roomCategory: '', 
                roomType: '',     
                hotelType: pkg.hotelCategory || '',
                checkIn: null, 
                checkOut: null, 
                mealPlan: loc.mealPlan || [],
                costPerAdult: 0,
                costPerChild: 0,
                costPerInfant: 0,
                noOfAdults: 0,
                noOfChildren: 0,
                noOfInfants: 0,
                totalCostOfAccommodation: 0,
                extraBeds: 0,
                extraMattress: 0,
                others: []
              }
            ]
          }
        ]
      }))
    );

    return { data };
  }


  async getHotelTermsForQuote(quoteId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._itineraryService.getQuoteData(quoteId).subscribe({
        next: (data) => {
          let hotelTerms = data.accommodations?.hotelTermsAndConditions;
          resolve(hotelTerms);
        },
        error: (error) => {
          reject(error);
        }
      })
    })
  }

  getContactsOfLead(leadId: any) {
    this._contactService.getAllContactsForLead(leadId, null, null, null).subscribe((data) => {
      this.patchContactDetailsInBookingDetails(data.data);
    }, (error) => {
      this._responseNotificationService.showMessage("Unable to get contacts for lead", true);
    })
  }

  // Deserializing data
  deserializeInclusionData(formData: any) {
    let data = {
      include: formData.inclusions,
      exclude: formData.exclusions,
      note: formData.inclusionAndExclusionNotes,
      exclusionNote: formData.exclusionNote,
      inclusionNote: formData.inclusionNote
    }

    return data;
  }

  deserializeTermsAndConditionsData(formData: any) {
    let data = {
      termsAndConditions: formData.data,
      note: formData.termsAndConditionNotes
    }
    return data;
  }

  deserializeCancellationPolicyData(formData: any) {
    let data = {
      cancellationPolicys: formData.data,
      note: formData.cancellationPolicyNotes
    }
    return data;
  }

  deserializeImportantInformationData(formData: any) {
    let data = {
      importantInformation: formData.data,
      note: formData.importantInformationNotes
    }
    return data;
  }

  // Patch voucher data during edit
  async patchVoucherData(formData: any) {
    this.voucherForm.patchValue({
      accommodationNotes: formData.accommodations ? formData.accommodations[0].accommodationNotes : null,
      accommodationsTermsAndConditions: formData.accommodationsTermsAndConditions[0]?.data,
      transportationNotes: formData.transportations ? formData.transportations[0].transportationNotes : null,
      sightSeeingNotes: formData.routeCraft ? formData.routeCraft[0].routeCraftNotes : null,
      transfersNotes: formData.transfers ? formData.transfers[0].transfersNotes : null,
      voucherNotes: formData.voucherNotes,
      hotelsAck: true,
      transfersAck: true,
      showHotels: formData.showHotels,
      showTransportation: formData.showTransportation,
      showTransfer: formData.showTransfer,
      showSightSeeing: formData.showSightSeeing,
      showInclusions: formData.showInclusions,
      showTerms: formData.showTerms,
      showCancellation: formData.showCancellation,
      showImportantInfo: formData.showImportantInfo,
      showNotes: formData.showNotes,
      guestDetailsMandatory: formData.guestDetailsMandatory, 
      bookingDetailsMandatory: formData.bookingDetailsMandatory
    })

    if (!formData.accommodationsTermsAndConditions[0]?.data) {
      let terms = await this.getHotelTermsForQuote(this.quoteId);
      this.voucherForm.patchValue({
        accommodationsTermsAndConditions: terms
      });
    }

    // Patching accommoation
    if (formData.accommodations) {
      this.patchDestinationsData(formData.accommodations[0].data);
    }

    // Patching transporations
    if (formData.transportations) {
      const transportArr = this.transportations;
      for (let transport of formData.transportations[0].data) {
        transportArr.push(this.createTransportationGroup(transport))
      }
    }

    // Patching transfers
    if (formData.transfers) {
      const tranferArr = this.transfers;
      for (let transfer of formData.transfers[0].data) {
        tranferArr.push(this.createTransfersGroup(transfer))
      }
    }


    // Patching routeCraft
    if (formData.routeCraft) {
      const sightseeingArr = this.freeTextDays;
      for (let day of formData.routeCraft[0].freeText) {
        sightseeingArr.push(this.createFreeTextGroup(day))
      }
    }

    this.updateSectionValidations();
    this.updateGuestDetailsValidations();
    this.updateBookingDetailsValidations();
  }

  // Patching quote data
  patchQuoteData(quoteData: any) {
    this.voucherForm.patchValue({
      accommodationNotes: quoteData.accommodations ? quoteData.accommodations.note : "",
      sightSeeingNotes: quoteData.routeCrafts ? quoteData.routeCrafts.note : "",
      voucherNotes: quoteData.notes ? quoteData.notes.note : "",
    });

    if (quoteData.transportations && this.serviceBasedSections.showTransfers && !this.serviceBasedSections.showTransportation) {
      this.voucherForm.patchValue({
        transfersNotes: quoteData.transportations ? quoteData.transportations.note : ""
      })
    }

    // Patching accommoation
    if (quoteData.accommodations && this.serviceBasedSections.showHotels) {
      this.patchDestinationsData(quoteData.accommodations.data);
      // Patching hotel terms and conditions
      this.voucherForm.patchValue({
        accommodationsTermsAndConditions: quoteData.accommodations?.hotelTermsAndConditions ? quoteData.accommodations?.hotelTermsAndConditions : []
      });
    }

    // Patching transporations
    if (this.voucherTypeVisibility.transportationVoucher) {
      const transportArr = this.transportations;
      let allTransportaions = this.createExistingTransportsList(quoteData)
      if (allTransportaions.length > 0) {
        for (let transport of allTransportaions) {
          transport.name = transport.transportationName;
          transportArr.push(this.createTransportationGroup(transport))
        }
      } else {
        this.voucherTypeVisibility.transportationVoucher = false;
      }
    }

    // Patching transfers
    if (quoteData.cars && this.serviceBasedSections.showTransfers && !this.serviceBasedSections.showTransportation) {
      const tranferArr = this.transfers;
      for (let transfer of quoteData.cars.data) {
        tranferArr.push(this.createTransfersGroup(transfer))
      }
    }

    // Patching routeCraft
    if (quoteData.routeCrafts) {
      const sightseeingArr = this.freeTextDays;
      for (let day of quoteData.routeCrafts.data) {
        sightseeingArr.push(this.createFreeTextGroup(day))
      }
    }

    // Update form validations based on generated voucher types

    this.updateSectionValidations();
   this.updateGuestDetailsValidations(); 
    this.storedInclusionData = quoteData.inclusionAndExclusions;
    this.storedCancellation = quoteData.cancellationPolicies;
    this.storedInformation = quoteData.importantInformations;
    this.storedTerms = quoteData.termsAndConditions;
  }

  get today(): Date {
    let date = new Date(this._globalService.getTodaysDateTime())
    return date;
  }

  convertToDate(value: any): any {
    if (!value) {
      return null;
    }
    return new Date(value);
  }

  // Function to update section validities based on their respective toggle buttons
  updateSectionValidations() {
    // Accommodation Section
    if (this.voucherTypeVisibility.accommodationVoucher && this.voucherForm.get('showHotels')?.value) {
      this.addAccommodationVoucherValidations();
    } else {
      this.removeAccommodationVoucherValidations();
    }

    // Transportation Section
    if (this.voucherTypeVisibility.transportationVoucher && this.voucherForm.get('showTransportation')?.value) {
      this.addTransportationVoucherValidations();
    } else {
      this.removeTransportationVoucherValidations();
    }

    // Transfers Section
    if (this.voucherTypeVisibility.transfersVoucher && this.voucherForm.get('showTransfer')?.value) {
      this.addTransfersVoucherValidations();
    } else {
      this.removeTransfersVoucherValidations();
    }

    // Sightseeing Section
    if (this.voucherTypeVisibility.sightSeeingVoucher && this.voucherForm.get('showSightSeeing')?.value) {
      this.addSightseeingVoucherValidations();
    } else {
      this.removeSightseeingVoucherValidations();
    }
  }

  // Creating single list from all transports from quote
  createExistingTransportsList(quoteData: any) {
    let transportList: any[] = [];
    // Add typeOfTransport for flights
    if (quoteData.flights) {
      quoteData.flights.data = quoteData.flights.data.map((flight: any) => ({
        ...flight,
        type: TRANSPORTATION_TYPES.FLIGHT
      }));
      transportList = [...transportList, ...quoteData.flights.data];
    }

    // Add typeOfTransport for trains
    if (quoteData.trains) {
      quoteData.trains.data = quoteData.trains.data.map((train: any) => ({
        ...train,
        type: TRANSPORTATION_TYPES.TRAIN
      }));
      transportList = [...transportList, ...quoteData.trains.data];
    }

    // Add typeOfTransport for buses
    if (quoteData.buses) {
      quoteData.buses.data = quoteData.buses.data.map((bus: any) => ({
        ...bus,
        type: TRANSPORTATION_TYPES.BUS
      }));
      transportList = [...transportList, ...quoteData.buses.data];
    }

    // Add typeOfTransport for cars
    if (quoteData.cars) {
      quoteData.cars.data = quoteData.cars.data.map((car: any) => ({
        ...car,
        type: TRANSPORTATION_TYPES.CAR
      }));
      transportList = [...transportList, ...quoteData.cars.data];
    }

    // Add typeOfTransport for ferry
    if (quoteData.ferries) {
      quoteData.ferries.data = quoteData.ferries.data.map((ferry: any) => ({
        ...ferry,
        type: TRANSPORTATION_TYPES.FERRY
      }));
      transportList = [...transportList, ...quoteData.ferries.data];
    }

    // Add typeOfTransport for Cruise
    if (quoteData.cruises) {
      quoteData.cruises.data = quoteData.cruises.data.map((cruise: any) => ({
        ...cruise,
        type: TRANSPORTATION_TYPES.CRUISE
      }));
      transportList = [...transportList, ...quoteData.cruises.data];
    }


    return transportList;
  }

  // Update validations

  // Generic function to set validators for a FormArray
  private setFormArrayValidators(formArray: FormArray, validatorsConfig: { [key: string]: any[] }, nestedArrayConfigs?: { [key: string]: { [key: string]: any[] } }) {
    formArray.controls.forEach((group: any) => {
      Object.keys(validatorsConfig).forEach(key => {
        group.get(key)?.setValidators(validatorsConfig[key]);
        group.get(key)?.updateValueAndValidity();
      });
      // Handle nested FormArrays if provided
      if (nestedArrayConfigs) {
        Object.keys(nestedArrayConfigs).forEach(nestedKey => {
          const nestedArray = group.get(nestedKey) as FormArray;
          if (nestedArray && Array.isArray(nestedArray.controls)) {
            nestedArray.controls.forEach((nestedGroup: any) => {
              Object.keys(nestedArrayConfigs[nestedKey]).forEach(nestedField => {
                nestedGroup.get(nestedField)?.setValidators(nestedArrayConfigs[nestedKey][nestedField]);
                nestedGroup.get(nestedField)?.updateValueAndValidity();
              });
            });
          }
        });
      }
    });
  }

  private setAccommodationValidators(valid: boolean) {
    // Loop through each destination
    this.destinationFormArray().controls.forEach((destinationGroup: any) => {
      // Loop through each location in the destination
      const locationsArray = destinationGroup.get('locations') as FormArray;
      locationsArray.controls.forEach((locationGroup: any) => {
        // Loop through each hotel in the location
        const hotelsArray = locationGroup.get('hotels') as FormArray;
        hotelsArray.controls.forEach((hotelGroup: any) => {
          hotelGroup.get('hotelName')?.setValidators(valid ? [Validators.required] : []);
          hotelGroup.get('hotelType')?.setValidators(valid ? [Validators.required] : []);
          hotelGroup.get('totalRooms')?.setValidators(valid ? [Validators.required, this._validationService.valueNotZeroValidator()] : []);
          hotelGroup.get('roomCategory')?.setValidators(valid ? [Validators.required] : []);
          hotelGroup.get('checkIn')?.setValidators(valid ? [Validators.required] : []);
          hotelGroup.get('checkOut')?.setValidators(valid ? [Validators.required] : []);
          hotelGroup.get('mealPlan')?.setValidators([]); // No validators
          hotelGroup.get('hotelFullAddress')?.setValidators([]); // No validators
          hotelGroup.get('adults')?.setValidators([]); // No validators
          hotelGroup.get('childrens')?.setValidators([]); // No validators
          hotelGroup.get('infants')?.setValidators([]); // No validators
          hotelGroup.get('extraBeds')?.setValidators([]); // No validators
          hotelGroup.get('checkInTime')?.setValidators([]); // No validators
          hotelGroup.get('checkOutTime')?.setValidators([]); // No validators

          // Update validity after setting validators
          Object.keys(hotelGroup.controls).forEach(key => {
            hotelGroup.get(key)?.updateValueAndValidity();
          });
        });
      });
    });
  }

  addAccommodationVoucherValidations() {
    this.setAccommodationValidators(true);
  }

  removeAccommodationVoucherValidations() {
    this.setAccommodationValidators(false);
  }

  private setGuestDetailsValidators(valid: boolean) {
  this.destinationFormArray().controls.forEach((destinationGroup: any) => {
    const locationsArray = destinationGroup.get('locations') as FormArray;
    locationsArray.controls.forEach((locationGroup: any) => {
      const hotelsArray = locationGroup.get('hotels') as FormArray;
      hotelsArray.controls.forEach((hotelGroup: any) => {
        const guestArray = hotelGroup.get('guestDetails') as FormArray;
        if (guestArray) {
          guestArray.controls.forEach((guest: any) => {
            guest.get('firstName')?.setValidators(valid ? [Validators.required] : []);
            guest.get('bookingId')?.setValidators(valid ? [Validators.required] : []);
            guest.get('firstName')?.updateValueAndValidity();
            guest.get('bookingId')?.updateValueAndValidity();
          });
        }
      });
    });
  });
}



updateGuestDetailsValidations() {
  const mandatory = this.voucherForm.get('guestDetailsMandatory')?.value;
  this.setGuestDetailsValidators(mandatory);
}
  private setTransportationValidators(valid: boolean) {
    const validatorsConfig: { [key: string]: any[] } = {
      type: valid ? [Validators.required] : [],
      name: valid ? [Validators.required] : [],
      departureDate: valid ? [Validators.required] : [],
      departureTime: valid ? [Validators.required] : [],
      arrivalDate: valid ? [Validators.required] : [],
      arrivalTime: valid ? [Validators.required] : [],
      departure: valid ? [Validators.required] : [],
      arrival: valid ? [Validators.required] : [],
      cabinBaggage: [],
      checkinBaggage: [],
    };
    const nestedArrayConfigs = {
      bookingDetails: {
        firstName: valid ? [Validators.required] : [],
        bookingId: valid ? [Validators.required] : [],
      }
    };
    this.setFormArrayValidators(this.transportations, validatorsConfig, nestedArrayConfigs);
  }

  private setBookingDetailsValidators(valid: boolean) {
    this.transportations.controls.forEach((transport: any) => {
      const bookingDetails = transport.get('bookingDetails') as FormArray;
      if (bookingDetails) {
        bookingDetails.controls.forEach((person: any) => {
          person.get('firstName')?.setValidators(valid ? [Validators.required] : []);
          person.get('bookingId')?.setValidators(valid ? [Validators.required] : []);
          person.get('firstName')?.updateValueAndValidity();
          person.get('bookingId')?.updateValueAndValidity();
        });
      }
    });
  }

  updateBookingDetailsValidations() {
    const mandatory = this.voucherForm.get('bookingDetailsMandatory')?.value;
    this.setBookingDetailsValidators(mandatory);
  }

  private clearAllBookingDetails() {
    this.transportations.controls.forEach((transport: any) => {
      const bookingDetails = transport.get('bookingDetails') as FormArray;
      if (bookingDetails) {
        bookingDetails.controls.forEach((person: any) => {
          person.get('firstName')?.setValue('');
          person.get('lastName')?.setValue('');
          person.get('bookingId')?.setValue('');
          person.get('pnrNumber')?.setValue('');
        });
      }
    });
  }

  addTransportationVoucherValidations() {
    this.setTransportationValidators(true);
  }

  removeTransportationVoucherValidations() {
    this.setTransportationValidators(false);
  }

  private setTransfersValidators(valid: boolean) {
    const validatorsConfig: { [key: string]: any[] } = {
      name: valid ? [Validators.required] : [],
      departureDate: valid ? [Validators.required] : [],
      departureTime: valid ? [Validators.required] : [],
      arrivalDate: valid ? [Validators.required] : [],
      arrivalTime: valid ? [Validators.required] : [],
      departure: valid ? [Validators.required] : [],
      arrival: valid ? [Validators.required] : [],
      bookingId: valid ? [Validators.required] : [],
      cabinBaggage: [],
    };
    this.setFormArrayValidators(this.transfers, validatorsConfig);
  }

  addTransfersVoucherValidations() {
    this.setTransfersValidators(true);
  }

  removeTransfersVoucherValidations() {
    this.setTransfersValidators(false);
  }

  private setSightseeingValidators(valid: boolean) {
    const validatorsConfig: { [key: string]: any[] } = {
      day: valid ? [Validators.required] : [],
      activities: valid ? [this._validationService.textEditorRequired()] : [],
    };
    this.setFormArrayValidators(this.freeTextDays, validatorsConfig);
  }

  addSightseeingVoucherValidations() {
    this.setSightseeingValidators(true);
  }

  removeSightseeingVoucherValidations() {
    this.setSightseeingValidators(false);
  }


  // Accomodation form functions

  destinationFormArray(): FormArray {
    return this.voucherForm.get('accommodations') as FormArray;
  }

  locationFormArray(destinationIndex: number): FormArray {
    return (this.destinationFormArray().at(destinationIndex).get('locations') as FormArray);
  }

  hotelsFormArray(destinationIndex: number, locationIndex: number): FormArray {
    return (this.locationFormArray(destinationIndex).at(locationIndex).get('hotels') as FormArray);
  }

  // Reactive form funtions
  createDestinationFormGroup(): FormGroup {
    let group = this._fb.group({
      destination: [""],
      locations: this._fb.array([]),
    })
    return group;
  }

  createLocationFormGroup(): FormGroup {
    let group = this._fb.group({
      locationName: [""],
      hotels: this._fb.array([]),
    })
    return group;
  }


private clearAllGuestDetails() {
  this.destinationFormArray().controls.forEach((destinationGroup: any) => {
    const locationsArray = destinationGroup.get('locations') as FormArray;
    locationsArray.controls.forEach((locationGroup: any) => {
      const hotelsArray = locationGroup.get('hotels') as FormArray;
      hotelsArray.controls.forEach((hotelGroup: any) => {
        const guestArray = hotelGroup.get('guestDetails') as FormArray;
        if (guestArray) {
          guestArray.controls.forEach((guest: any) => {
            guest.get('firstName')?.setValue('');
            guest.get('lastName')?.setValue('');
            guest.get('bookingId')?.setValue('');
          });
        }
      });
    });
  });
}

  // patch accommodation data funtions
  createAccommodationFormGroup(hotel: any): FormGroup {
    const group = this._fb.group({
      hotelName: [hotel.hotelName],
      hotelType: [hotel.hotelType],
      totalRooms: [hotel.totalRooms, []],
      roomCategory: [this.getRoomCategoryString(hotel.rooms) || ""],
      checkIn: [this.convertToDate(hotel.checkIn), []],
      checkOut: [this.convertToDate(hotel.checkOut), []],
      checkInTime: [this.convertToDate(hotel.checkIn), []],
      checkOutTime: [this.convertToDate(hotel.checkOut), []],
      mealPlan: [hotel.mealPlan],
      hotelFullAddress: [hotel.hotelFullAddress],
      guestDetails: this._fb.array(this.createDefaultGuestList(hotel)),
      adults: [{ value: this.noOfAdults ? this.noOfAdults : hotel.adults, disabled: true }],
      childrens: [{ value: this.noOfChildren, disabled: true }],
      infants: [{ value: this.noOfInfants, disabled: true }],
      extraBeds: [hotel.extraBeds]
    });
    return group;
  }

  private getRoomCategoryString(rooms: {roomCategory: string, occupancy: string}[]): string {
    if (!rooms || rooms.length === 0) {
      return '';
    }
    // Create a map to hold the counts of each room category and return a string representation of the counts
    const roomCounts: { [key: string]: number } = {};
    rooms.forEach(room => {
      const key = `${room.roomCategory}`;
      roomCounts[key] = (roomCounts[key] || 0) + 1;
    });
    const categories = Object.keys(roomCounts);
    let res = categories.length === 1
      ? categories[0]
      : Object.entries(roomCounts).map(([category, count]) => `${count} ${category}`).join(', ');
    return res;
  }
  patchDestinationsData(destinations: any[]) {
    const destinationArray = this.destinationFormArray();
    destinationArray.clear();
    destinations.forEach((destination: any, destinationIndex: number) => {
      const destinationGroup = this.createDestinationFormGroup();
      destinationGroup.patchValue({
        destination: destination.destination || ""
      })
      destinationArray.push(destinationGroup);
      this.locationFormArray(destinationIndex).clear();
      destination.locations.forEach((location: any, locationIndex: number) => {
        const locationGroup = this.createLocationFormGroup();
        locationGroup.patchValue({
          locationName: location.locationName || ""
        });
        locationGroup.get("locationName")?.disable();
        this.locationFormArray(destinationIndex).push(locationGroup);
        this.hotelsFormArray(destinationIndex, locationIndex).clear();
        location.hotels.forEach((hotel: any, hotelIndex: number) => {
          const hotelGroup = this.createAccommodationFormGroup(hotel);
          this.hotelsFormArray(destinationIndex, locationIndex).push(hotelGroup);
        });
      });
    });
  }

  // Transportation form functions

  createTransportationGroup(transport: any): FormGroup {
    const group = this._fb.group({
      type: [{ value: transport.type, disabled: true }, []],
      name: [transport.name, []],
      departureDate: [transport.departureTime ? this.convertToDate(transport.departureTime) : null, []],
      departureTime: [transport.departureTime ? this.convertToDate(transport.departureTime) : null, []],
      arrivalDate: [transport.arrivalTime ? this.convertToDate(transport.arrivalTime) : null, []],
      arrivalTime: [transport.arrivalTime ? this.convertToDate(transport.arrivalTime) : null, []],
      departure: [transport.departure, []],
      arrival: [transport.arrival, []],
      bookingDetails: transport.bookingDetails?.length ? this._fb.array(this.getStoredBookingDetails(transport.bookingDetails)) : this._fb.array(this.createDefaultBookingDetailsList()),
      cabinBaggage: [transport.cabinBaggage ? transport.cabinBaggage : "7Kgs", []],
      checkinBaggage: [transport.checkinBaggage ? transport.checkinBaggage : "25Kgs", []],
      adults: [{ value: this.noOfAdults ? this.noOfAdults : transport.adults, disabled: true }],
      childrens: [{ value: this.noOfChildren, disabled: true }],
      infants: [{ value: this.noOfInfants, disabled: true }]
    });

    let type = group.get('type')?.value;
    switch (type) {
      case TRANSPORTATION_TYPES.FLIGHT: {
        break
      }
      case TRANSPORTATION_TYPES.TRAIN: {
        group.get('cabinBaggage')?.setValue("");
        group.get('checkinBaggage')?.setValue("");
        group.get('cabinBaggage')?.disable();
        group.get('checkinBaggage')?.disable();
        break
      }
      case TRANSPORTATION_TYPES.BUS: {
        group.get('checkinBaggage')?.setValue("");
        group.get('checkinBaggage')?.disable();
        break
      }
      case TRANSPORTATION_TYPES.CAR: {
        group.get('checkinBaggage')?.setValue("");
        group.get('pnrNumber')?.disable();
        group.get('checkinBaggage')?.disable();
        break
      }
      case TRANSPORTATION_TYPES.FERRY: {
        break
      }
      case TRANSPORTATION_TYPES.CRUISE: {
        break
      }
    }

    return group;
  }

createDefaultBookingDetailsList(): any[] {
  let res = [];
  if (this.noOfAdults) {
    for (let i = 0; i < this.noOfAdults + this.noOfChildren + this.noOfInfants; i++) {
      res.push(this.bookingDetailsFormGroup())
    }
    return res;
  } else {
    return [this.bookingDetailsFormGroup()];
  }
}

  getStoredBookingDetails(bookingDetails: any): any[] {
    let res: any[] = [];

    bookingDetails.forEach((element: any) => {
      let group = this._fb.group({
        firstName: element.firstName,
        lastName: element.lastName,
        bookingId: element.bookingId,
        pnrNumber: element.pnrNumber
      })

      res.push(group);
    });
    return res;
  }

  patchContactDetailsInBookingDetails(contactsList: any) {
    contactsList.forEach((contact: any, index: number) => {
      if (this.transportations.length > index) {  // Ensure the transport exists at the current index
        const bookingDetails = this.bookingDetailsFortransport(index);  // Get bookingDetails for the transport at current index
        if (bookingDetails.length > 0) {
          const bookingDetailGroup = bookingDetails.at(0) as FormGroup; // Assume first group, update this logic as needed
          bookingDetailGroup.patchValue({
            firstName: contact.firstName,
            lastName: contact.lastName
          });
        }
      }
    });
  }

  get transportations(): FormArray {
    return this.voucherForm.get('transportations') as FormArray;
  }

  removeTransportation(index: number) {
    this.transportations.removeAt(index);
  }

  bookingDetailsFortransport(transportIndex: number): FormArray {
    return this.transportations.at(transportIndex).get("bookingDetails") as FormArray
  }

  bookingDetailsFormGroup(): FormGroup {
    return this._fb.group({
      firstName: ['', Validators.required],
      lastName: [''],
      bookingId: ['', Validators.required],
      pnrNumber: ['']
    })
  }

  // Transfers functions

  createTransfersGroup(tranfer: any): FormGroup {
    const group = this._fb.group({
      type: [TRANSPORTATION_TYPES.CAR],
      name: [tranfer.name],
      departureDate: [tranfer.departureTime  ? this.convertToDate(tranfer.departureTime ) : null],
      departureTime: [tranfer.departureTime  ? this.convertToDate(tranfer.departureTime ) : null],
      arrivalTime: [tranfer.arrivalTime ? this.convertToDate(tranfer.arrivalTime) : null],
      arrivalDate: [tranfer.arrivalTime ? this.convertToDate(tranfer.arrivalTime) : null],
      departure: [tranfer.departure],
      arrival: [tranfer.arrival],
      bookingId: [tranfer.bookingId],
      cabinBaggage: [tranfer.cabinBaggage],
      adults: [{ value: this.noOfAdults ? this.noOfAdults : tranfer.adults, disabled: true }],
      childrens: [{ value: this.noOfChildren, disabled: true }],
      infants: [{ value: this.noOfInfants, disabled: true }]
    });
    return group;
  }

  get transfers(): FormArray {
    return this.voucherForm.get('tranfersCars') as FormArray;
  }

  removeTransfers(index: number) {
    this.transfers.removeAt(index);
  }

  // Sighseeing functions

  createFreeTextGroup(day: any) {
    const group = this._fb.group({
      day: [day.day],
      activities: [day.activities]
    });
    return group;
  }

  get freeTextDays() {
    return this.voucherForm.get('sightSeeingDays') as FormArray;
  }


  // Inclusions and exclusions and others

  submitInclusions(ev: any) {
    this.storedInclusionData = ev;
  }
  submitTerms(ev: any) {
    this.storedTerms = ev;
  }
  submitCancellation(ev: any) {
    this.storedCancellation = ev;
  }
  submitImportant(ev: any) {
    this.storedInformation = ev;
  }

  // General componnet form functions

  async closeModal(submitted: boolean = false) {
    if (this.voucherFormIsDirty && !submitted) {
      if (await this._globalService.confirmActionPopup("You have unsaved data, confirm to close.")) {
        this.dismissModal(submitted);
      }
    } else {
      this.dismissModal(submitted);
    }
  }


  dismissModal(submitted: boolean) {
    this._modalController.dismiss({
      'dismissed': true,
      'submitted': submitted
    });
  }

  // internal navigation
  scrollTo(section: string) {
    // Scroll to the specific section smoothly
    document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
    // Remove 'active' class from all links
    document.querySelectorAll('.navlist').forEach(link => {
      link.classList.remove('active');
    });
    // Add 'active' class to the clicked link
    document.getElementById(`link-${section}`)?.classList.add('active');
  }

  // check if fields is empty or not
  isFieldEmptyInArray(formArray: FormArray, index: number, formControlName: string): boolean {
    return formArray.at(index).get(formControlName)?.value === "" || formArray.at(index).get(formControlName)?.value === null || formArray.at(index).get(formControlName)?.value === undefined;
  }
  isFieldZeroInArray(formArray: FormArray, index: number, formControlName: string): boolean {
    return formArray.at(index).get(formControlName)?.value === 0 || formArray.at(index).get(formControlName)?.value === '0';
  }
  isFieldEmptyInForm(formControlName: string): boolean {
    return this.voucherForm.get(formControlName)?.value === "" || this.voucherForm.get(formControlName)?.value === null || this.voucherForm.get(formControlName)?.value === undefined;
  }
  isFieldBookingDetailsCellEmpty(formArray: FormArray, arrayIndex: number, tableArrayName: string, tableIndex: number, tableControlName: string): boolean {
    let tableArrray = formArray.at(arrayIndex).get(tableArrayName) as FormArray;
    let cellValue = tableArrray.at(tableIndex).get(tableControlName)?.value;
    return cellValue === "" || cellValue === null || cellValue === undefined;
  }

  // Submission

  async onSubmit() {
    if (this.voucherForm.valid) {
      await this.inclusionsAndExclusionsComponent?.sendDataToVoucher();
      await this.termsAndConditionsComponent?.sendDataToVoucher();
      await this.cancellationPolicyComponent?.sendDataToVoucher();
      await this.importantInformationComponent?.sendDataToVoucher();

      this.serializeFormData(this.voucherForm.getRawValue()).then(async formData => {
        if (formData.accommodations) {
          if (this.checkMultipleHotelsAtLocation(formData.accommodations[0]?.data)) {
            await this._globalService.customAlert("Multiple hotels are selected at the same location. Please ensure there exists only one hotel per location to generate a voucher.");
            return;
          }
        }
        if (this.editVoucherId) {
          this._voucherService.updateVoucher(this.editVoucherId, formData).subscribe(async (data) => {
            this._responseNotificationService.showMessage("Voucher updated successfully!");
            this._modalPopupService.openVocuherView(data.voucherId, data.leadId, data.itineraryId);
            this.closeModal();
            this._reloadService.triggerVouchersReload();
          })
        } else {
          this._voucherService.addVoucher(formData).subscribe(async (data) => {
            this._responseNotificationService.showMessage("Voucher added successfully!");
            await this.makeQuoteConverted(formData.itineraryId);
            this._reloadService.triggerQuotesReload();
            this._router.navigate([`leads/details/${data.leadId}`]);
            this.closeModal();
            if (!this.hideInvoice) {
              if (await this._globalService.confirmActionPopup("Continue to generate invoice?")) {
                this._modalPopupService.openInvoiceForm(null, data.leadId, formData.itineraryId, () => { });
              } else {
                this._modalPopupService.openVocuherView(data.voucherId, data.leadId, data.itineraryId);
              }
            }
            this._reloadService.triggerVouchersReload();
          }, (error) => {
            this._responseNotificationService.showMessage("Something went wrong, try again later", true)
          })
        }
      })
    } else {
      this.voucherForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Form is invalid, please fill all required fields.");
    }
  }

  async makeQuoteConverted(quoteId: any) {
    this._statusUpdateService.updateStatusOfRecord(ENTITY_NAMES.QUOTE, quoteId, RECORD_STATUS_VALUES.CONVERTED).subscribe();
    // Adding revenue to quote -> itinerary details
    var revenue = 0;
    if(this.quoteData.costAndPricings?.totalQuoteCost){
      revenue = this.quoteData.costAndPricings?.totalQuoteCost;
    } else if(this.quoteData.costAndPricings?.landPackages[0]?.packageIncludingAirfare) {
      revenue = this.quoteData.costAndPricings?.landPackages[0]?.packageIncludingAirfare
    }

    this.quoteData.itineraryDetails.revenue = revenue;
    this._itineraryService.addItineraryDetails(this.quoteData.itineraryDetails).subscribe();
    
  }

  private async serializeFormData(formData: any) {
    const serializedData = {
      leadId: this.leadId,
      clientId: this.clientId,
      itineraryId: this.quoteId,
      voucherId: this.editVoucherId ? this.editVoucherId : null,
      accommodations: this.voucherTypeVisibility.accommodationVoucher ? [{
        data: formData.accommodations.map((destination: any) => {
          return {
            destination: destination.destination,
            locations: destination.locations.map((location: any) => {
              return {
                locationName: location.locationName,
                hotels: location.hotels.map((hotel: any) => {
                  return {
                    ...hotel,
                    checkIn: this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(hotel.checkIn), this.convertToDate(hotel.checkInTime))),
                    checkOut: this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(hotel.checkOut), this.convertToDate(hotel.checkOutTime))),
                  };
                })
              };
            })
          };
        }),
        accommodationNotes: formData.accommodationNotes
      }] : null,
      accommodationsTermsAndConditions: [{
        data: formData.accommodationsTermsAndConditions,
      }],
      transportations: this.voucherTypeVisibility.transportationVoucher ? [{
        data: formData.transportations.map((transport: any) => ({
          ...transport,
          departureTime: this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(transport.departureDate), this.convertToDate(transport.departureTime))),
          arrivalTime: this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(transport.arrivalDate), this.convertToDate(transport.arrivalTime))),
        })),
        transportationNotes: formData.transportationNotes
      }] : null,
      routeCraft: this.voucherTypeVisibility.sightSeeingVoucher ? [{
        freeText: formData.sightSeeingDays,
        selectionOption: null,
        routeCraftNotes: formData.sightSeeingNotes
      }] : null,
      transfers: this.voucherTypeVisibility.transfersVoucher ? [{
        data: formData.tranfersCars.map((transport: any) => ({
          ...transport,
          departureTime: this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(transport.departureDate), this.convertToDate(transport.departureTime))),
          arrivalTime: this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(transport.arrivalDate), this.convertToDate(transport.arrivalTime)))
        })),
        transfersNotes: formData.transfersNotes
      }] : null,
      inclusionAndExclusions: [{
        inclusions: this.storedInclusionData.include,
        exclusions: this.storedInclusionData.exclude,
        inclusionAndExclusionNotes: this.storedInclusionData.note,
        inclusionNote: this.storedInclusionData.inclusionNote,
        exclusionNote: this.storedInclusionData.exclusionNote
      }],
      termsAndConditions: [{
        data: this.storedTerms.termsAndConditions,
        termsAndConditionNotes: this.storedTerms.note
      }],
      cancellationPolicies: [{
        data: this.storedCancellation.cancellationPolicys,
        cancellationPolicyNotes: this.storedCancellation.note
      }],
      importantInformations: [{
        data: this.storedInformation.importantInformation,
        importantInformationNotes: this.storedInformation.note
      }],
      voucherNotes: formData.voucherNotes,
      showHotels: formData.showHotels,
      showTransportation: formData.showTransportation,
      showTransfer: formData.showTransfer,
      showSightSeeing: formData.showSightSeeing,
      showInclusions: formData.showInclusions,
      showTerms: formData.showTerms,
      showCancellation: formData.showCancellation,
      guestDetailsMandatory: formData.guestDetailsMandatory, 
      bookingDetailsMandatory: formData.bookingDetailsMandatory,
      showImportantInfo: formData.showImportantInfo,
      showNotes: formData.showNotes,
      organizationId: this.voucherData?.organizationId,
      id: this.voucherData ? this.voucherData.id : null,
      ownershipRole: this.voucherData ? this.voucherData.ownershipRole : this.leadDetails?.ownershipRole,
      ownership: this.voucherData ? this.voucherData.ownership : this.leadDetails?.ownership,
      ownershipName: this.voucherData ? this.voucherData.ownershipName : this.leadDetails?.ownershipName,
      category: this.voucherData ? this.voucherData.category : null,
      status: this.voucherData ? this.voucherData.status : null,
    }
    return serializedData;
  }


  handleFirstNameChangeInTransport(event: any, personIndex: number) {
    let value = event.target.value;
    this.transportations.controls.forEach((control: any, transportIndex: any) => {
      let bookingDetails = this.bookingDetailsFortransport(transportIndex);
      bookingDetails.at(personIndex).get('firstName')?.setValue(value);
    })
  }

  handleLastNameChangeInTransport(event: any, personIndex: number) {
    let value = event.target.value;
    this.transportations.controls.forEach((control: any, transportationIndex: any) => {
      let bookingDetails = this.bookingDetailsFortransport(transportationIndex);
      bookingDetails.at(personIndex).get('lastName')?.setValue(value);
    })
  }

  handleBookingIdChangeInTransport(event: any, transportIndex: number, personIndex: number) {
    if (personIndex === 0) {
      let value = event.target.value;
      let bookingDetails = this.bookingDetailsFortransport(transportIndex);

      bookingDetails.controls.forEach((person, bookingIndex) => {
        if (bookingIndex === 0) {
          return;
        }
        if (!person.get('bookingId')?.value) {
          person.get('bookingId')?.setValue(value);
        }

      });
    }
  }

  handlePnrNumberChangeInTransport(event: any, transportIndex: number, personIndex: number) {
    if (personIndex === 0) {
      let value = event.target.value;
      let bookingDetails = this.bookingDetailsFortransport(transportIndex);

      bookingDetails.controls.forEach((person, bookingIndex) => {
        if (bookingIndex === 0) {
          return;
        }
        if (!person.get('pnrNumber')?.value) {
          person.get('pnrNumber')?.setValue(value);
        }

      });
    }
  }
  // Check Multiple hotels added at same locaton for validation
  checkMultipleHotelsAtLocation(accommodationData: any[]): boolean {
    return accommodationData.some(destination =>
      destination.locations.some((location: any) =>
        location.hotels && location.hotels.length > 1
      )
    );
  }
createDefaultGuestList(hotel: any): FormGroup[] {

  // Edit Mode
  if (hotel.guestDetails && hotel.guestDetails.length > 0) {
    return hotel.guestDetails.map((guest: any) =>
      this.guestDetailsFormGroup(guest)
    );
  }

  // New Voucher
  const adults = this.noOfAdults || hotel.adults || 0;
  const children = this.noOfChildren || hotel.childrens || 0;
  const infants = this.noOfInfants || hotel.infants || 0;
  const total = adults + children + infants;
  const count = total > 0 ? total : 1;

  const rows: FormGroup[] = [];
  for (let i = 0; i < count; i++) {
    rows.push(this.guestDetailsFormGroup({
      firstName: '',
      lastName: '',
      bookingId: ''
    }));
  }

  return rows;
}
guestDetailsFormGroup(data: any = {}): FormGroup {
  return this._fb.group({
    firstName: [data.firstName || '', []],
    lastName:  [data.lastName  || ''],
    bookingId: [data.bookingId || '', []]
  });
}

guestDetailsForHotel(destIndex: number, locationIndex: number, hotelIndex: number): FormArray {
  return this.hotelsFormArray(destIndex, locationIndex)
    .at(hotelIndex).get('guestDetails') as FormArray;
}

// Auto-fill bookingId from row 0 to other empty rows (same as transport)
handleBookingIdChangeInHotel(event: any, destIndex: number, locationIndex: number, hotelIndex: number, personIndex: number) {
  if (personIndex === 0) {
    const value = event.target.value;
    const guestDetails = this.guestDetailsForHotel(destIndex, locationIndex, hotelIndex);
    guestDetails.controls.forEach((person, i) => {
      if (i === 0) return;
      if (!person.get('bookingId')?.value) {
        person.get('bookingId')?.setValue(value);
      }
    });
  }
}
private syncGuestFieldToTransport(guestIndex: number, field: 'firstName' | 'lastName', value: string) {
  this.transportations.controls.forEach((transport: any) => {
    const bookingDetails = transport.get('bookingDetails') as FormArray;
    if (bookingDetails && bookingDetails.length > guestIndex) {
      const person = bookingDetails.at(guestIndex);
      if (person && !person.get(field)?.value) {
        person.get(field)?.setValue(value);
      }
    }
  });
}
handleFirstNameChangeInHotel(
  event: any,
  destIndex: number,
  locationIndex: number,
  hotelIndex: number,
  guestIndex: number
) {
  const value = event.target.value;

  this.destinationFormArray().controls.forEach((dest: any, dIdx: number) => {
    this.locationFormArray(dIdx).controls.forEach((loc: any, lIdx: number) => {
      this.hotelsFormArray(dIdx, lIdx).controls.forEach((hotel: any, hIdx: number) => {

        if (dIdx === destIndex && lIdx === locationIndex && hIdx === hotelIndex) {
          return;
        }

        const guestDetails = hotel.get('guestDetails') as FormArray;
        const guest = guestDetails.at(guestIndex);

        if (guest && !guest.get('firstName')?.value) {
          guest.get('firstName')?.setValue(value);
        }
      });
    });
  });
  this.syncGuestFieldToTransport(guestIndex, 'firstName', value); 
}

handleLastNameChangeInHotel(
  event: any,
  destIndex: number,
  locationIndex: number,
  hotelIndex: number,
  guestIndex: number
) {
  const value = event.target.value;

  this.destinationFormArray().controls.forEach((dest: any, dIdx: number) => {
    this.locationFormArray(dIdx).controls.forEach((loc: any, lIdx: number) => {
      this.hotelsFormArray(dIdx, lIdx).controls.forEach((hotel: any, hIdx: number) => {
        if (dIdx === destIndex && lIdx === locationIndex && hIdx === hotelIndex) {
          return;
        }
        const guestDetails = hotel.get('guestDetails') as FormArray;
        const guest = guestDetails.at(guestIndex);
        if (guest && !guest.get('lastName')?.value) {
          guest.get('lastName')?.setValue(value);
        }
      });
    });
  });
  this.syncGuestFieldToTransport(guestIndex, 'lastName', value); 
}

}


